import React from 'react';
import { useGeneralStore } from 'src/store';
import { AnimatedDots } from '@components/shared/animated-dots/AnimatedDots';
import { LandingHeader } from './components/LandingHeader';
import { Hero } from './components/Hero';
import { FeatureCards } from './components/FeatureCards';
import { PlusBenefits } from './components/PlusBenefits';
import { WhoQualifies } from './components/WhoQualifies';
import { PlanHighlights } from './components/PlanHighlights';
import { EasySteps } from './components/EasySteps';
import { PlansPreview } from './components/PlansPreview';
import { Testimonials } from './components/Testimonials';
import { CtaBar } from './components/CtaBar';
import { LandingFooter } from './components/LandingFooter';
import { SmoothScroll } from './components/SmoothScroll';

const LandingPage: React.FC = () => {
  const isLoadingConfig = useGeneralStore((s) => s.isLoadingConfig);

  // Hold the page on a loader until branding/landing settings arrive, so we
  // don't flash the mock fallback content before the real data loads.
  if (isLoadingConfig) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#fbf7ef]">
        <AnimatedDots />
      </div>
    );
  }

  return (
    <main className="min-h-screen bg-[#fbf7ef] text-[#23262C] antialiased">
      <SmoothScroll />
      <LandingHeader />
      <div className="flex flex-col gap-[38px] max-[1200px]:gap-8">
        <Hero />
        <FeatureCards />
        <PlusBenefits />
        <WhoQualifies />
        <PlanHighlights />
        <EasySteps />
        <PlansPreview />
        <Testimonials />
        <CtaBar />
        <LandingFooter />
      </div>
    </main>
  );
};

export default LandingPage;
